import { createStyles } from '@material-ui/styles'
import { ThemeType } from 'theme'
export const RotationCheckStyles = (theme: ThemeType) =>
  createStyles({
    container: {
      display: 'flex',
      width: '100vw',
      height: '100vh',
      position: 'fixed',
      zIndex: 2600,
    },
    'inner-container': {
      margin: 'auto',
      backgroundColor: '#f9fcfc',
      padding: '1.5rem',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      fontSize: '16px',
      lineHeight: '1.19',
      letterSpacing: '0.24px',
      color: '#003676',
      borderRadius: '10px',
    },
    'bold-text': {
      fontWeight: 'bold',
    },
    divider: {
      minWidth: 400,
      margin: 18,
      height: 0,
      border: 'dashed 0.5px #003676',
    },
    'locked-screen-container': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '100vh',
      width: '100vw',
    },
    'locked-screen': {
      animation: '$fadeIn 300ms ease-in forwards',
    },
    'backdrop-blur': {
      backgroundColor: theme.palette.primary.dark,
    },
    '@supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none))': {
      'backdrop-blur': {
        backgroundColor: theme.palette.primary.dark,
        '-webkit-backdrop-filter': 'blur(20px)',
        backdropFilter: 'blur(20px)',
      },
    },
    '@keyframes fadeIn': {
      from: { backgroundColor: 'transparent' },
      to: { backgroundColor: theme.palette.primary.main },
    },
  })
